<template>
  <div>
    <vue-element-loading
      is-full-screen
      :active="loading"
      spinner="bar-fade-scale"
      color="#152d51"
    />
    <AuthorizationPage
      v-if="step == 'authorize'"
      @auth:succeed="changePhoneViaAuthorize"
    />
    <ChangePhone
      v-if="step == 'change'"
      @next="step = 'otp'"
      @auth="
        step = 'authorize';
        IsProfile = false;
      "
    />
    <OTP v-if="step == 'otp'"></OTP>
  </div>
</template>

<script>
import api from "@/api";
import ChangePhone from "@/components/changePhone/changePhone.vue";
import OTP from "@/components/changePhone/otp.vue";
import AuthorizationPage from "@/components/Authorization.vue";
import VueElementLoading from "vue-element-loading";
export default {
  components: {
    AuthorizationPage,
    ChangePhone,
    OTP,
    VueElementLoading,
  },
  data() {
    return {
      step: "",
      loading: true,
    };
  },
  mounted() {
    let { apptype } = this.$route.query;
    if (apptype != "line") {
      // Authorize instead
      this.loading = false;
      this.step = "authorize";
    }
  },
  methods: {
    changePhoneViaAuthorize() {
      this.$store.commit("setChangePhoneMethod", "authorize");
      this.step = "change";
    },
    async fetchUserData() {
      this.loading = true;
      let res = await api.getUser(this.userId);
      this.loading = false;
      if (
        res.responsecode == 200 &&
        res.data.id &&
        res.data.status == "ผูกบัญชีแล้ว"
      ) {
        this.$store.commit("setChangePhoneMethod", "sync");
        this.step = "change";
      } else {
        this.step = "authorize";
      }
    },
  },
  computed: {
    userId() {
      return this.$store.state.profile.userId;
    },
  },
  watch: {
    userId: {
      immediate: true,
      handler(userId) {
        if (userId && this.$route.query.apptype == "line") {
          this.fetchUserData();
        }
      },
    },
  },
};
</script>
